export default __webpack_public_path__ + "static/media/5.646deaf1.png";